// extracted by mini-css-extract-plugin
module.exports = {"scrollingContainer":"ScrollingContainer_scrollingContainer__2WbOU"};